// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".template[data-v-5377c962] {\n  width: 100%;\n}\n[data-v-5377c962] .el-dialog__body {\n  padding: 20px;\n  padding-top: 10px;\n}\n[data-v-5377c962] .el-dialog__title {\n  font-weight: bold;\n}\n.dialog-top[data-v-5377c962] {\n  line-height: 30px;\n}\n.dialog-center[data-v-5377c962] {\n  height: calc(70vh - 30px);\n}\n[data-v-5377c962] .radioTable .el-table__header-wrapper .el-table-column--selection .cell {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
